import { useEffect, useRef } from 'react';

/** document 스크롤 0~1 → ARBackground scrollProgressRef 에 전달 */
export function useWindowScrollProgressRef() {
  const scrollProgressRef = useRef(0);

  useEffect(() => {
    const update = () => {
      const el = document.documentElement;
      const maxScroll = el.scrollHeight - window.innerHeight;
      if (maxScroll <= 0) {
        scrollProgressRef.current = 0;
        return;
      }
      scrollProgressRef.current = Math.min(
        1,
        Math.max(0, window.scrollY / maxScroll)
      );
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return scrollProgressRef;
}
